/* CNOIR "Edit" collection page (2026-10-18): shape tabs, material chips, sort, show-all, band placement. */
(function () {
  document.querySelectorAll('[data-cnoir-edit]').forEach(function (root) {
    var grid = root.querySelector('[data-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.cce__card'));
    var band = grid.querySelector('[data-band]');
    var initial = parseInt(root.getAttribute('data-initial') || '16', 10);
    var S = { shape: '', mat: '', sort: 'feat', all: false };

    // Seasonal band line: hide after its date.
    if (band) band.querySelectorAll('[data-until]').forEach(function (el) {
      var d = new Date(el.getAttribute('data-until') + 'T23:59:59');
      if (!isNaN(d) && new Date() > d) el.remove();
    });

    // Counts on tabs; hide tabs and chips with no pieces.
    function count(fn) { return cards.filter(fn).length; }
    root.querySelectorAll('[data-shape]').forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      var v = b.getAttribute('data-shape');
      var n = v ? count(function (c) { return c.dataset.shape === v; }) : cards.length;
      var sup = b.querySelector('sup'); if (sup) sup.textContent = n;
      if (!n) b.hidden = true;
    });
    // Biggest shapes first (the keyword order in settings is for matching, not display).
    var tabsEl = root.querySelector('.cce__tabs');
    Array.prototype.slice.call(tabsEl.querySelectorAll('button[data-shape]:not([data-shape=""])'))
      .sort(function (a, b) { return (+b.querySelector('sup').textContent) - (+a.querySelector('sup').textContent); })
      .forEach(function (b) { tabsEl.appendChild(b); });
    root.querySelectorAll('button[data-mat]').forEach(function (b) {
      var v = b.getAttribute('data-mat');
      if (v && !count(function (c) { return c.dataset.mat === v; })) b.hidden = true;
    });

    // A row with only one real choice is noise: hide it.
    var liveTabs = Array.prototype.filter.call(root.querySelectorAll('.cce__tabs button[data-shape]:not([data-shape=""])'), function (b) { return !b.hidden; });
    if (liveTabs.length < 2) { var tn = root.querySelector('.cce__tabs'); if (tn) tn.hidden = true; }
    var liveChips = Array.prototype.filter.call(root.querySelectorAll('button[data-mat]:not([data-mat=""])'), function (b) { return !b.hidden; });
    if (liveChips.length < 2) { var cn = root.querySelector('.cce__chips'); if (cn) cn.hidden = true; }

    function render() {
      var list = cards.filter(function (c) {
        return (!S.shape || c.dataset.shape === S.shape) && (!S.mat || c.dataset.mat === S.mat);
      });
      var order = list.slice();
      if (S.sort === 'lo') order.sort(function (a, b) { return a.dataset.price - b.dataset.price || a.dataset.i - b.dataset.i; });
      else if (S.sort === 'hi') order.sort(function (a, b) { return b.dataset.price - a.dataset.price || a.dataset.i - b.dataset.i; });
      else order.sort(function (a, b) { return a.dataset.i - b.dataset.i; });
      cards.forEach(function (c) { c.hidden = true; });
      var limit = S.all ? order.length : Math.min(order.length, initial);
      order.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= limit; });
      if (band) {
        var shown = order.filter(function (c) { return !c.hidden; });
        if (shown.length > 8) { shown[7].after(band); band.hidden = false; } else { band.hidden = true; }
      }
      root.querySelector('[data-total]').textContent = list.length + (list.length === 1 ? ' piece' : ' pieces');
      root.querySelector('[data-empty]').hidden = list.length > 0;
      var more = root.querySelector('[data-more]');
      more.hidden = S.all || order.length <= initial;
      more.querySelector('[data-showing]').textContent = 'Showing ' + limit + ' of ' + order.length;
      more.querySelector('[data-showall]').textContent = 'Show all ' + order.length;
      root.querySelectorAll('.cce__tabs button').forEach(function (b) { b.setAttribute('aria-current', String(b.getAttribute('data-shape') === S.shape)); });
      root.querySelectorAll('button[data-mat]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mat') === S.mat)); });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-shape')) { S.shape = b.getAttribute('data-shape'); S.all = false; render(); }
      else if (b.hasAttribute('data-mat')) { S.mat = b.getAttribute('data-mat'); S.all = false; render(); }
      else if (b.hasAttribute('data-showall')) { S.all = true; render(); }
    });
    var sel = root.querySelector('[data-sort]');
    if (sel) sel.addEventListener('change', function () { S.sort = sel.value; render(); });

    // Deep link: ?shape=Puffers&material=Suede
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('shape')) S.shape = q.get('shape');
      if (q.get('material')) S.mat = q.get('material');
    } catch (e) {}
    render();
  });

  // Rotation builder (trousers): pick 2-3 pairs, see the saving, add them all at once.
  // Saving mirrors The Noir Rotation automatic discount: 2 eligible pairs 10% off, 3+ 20% off; excluded pairs never count.
  document.querySelectorAll('[data-cnoir-edit]').forEach(function (root) {
    var tray = root.querySelector('[data-rot-tray]');
    if (!tray) return;
    var cur = tray.getAttribute('data-currency') || '£';
    var money = function (c) { var n = c / 100; return cur + n.toLocaleString('en-GB', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
    var picked = []; // {h, id, p, elig, name}
    function paint() {
      var elig = picked.filter(function (x) { return x.elig; });
      var total = picked.reduce(function (a, x) { return a + x.p; }, 0);
      var eTotal = elig.reduce(function (a, x) { return a + x.p; }, 0);
      var save = elig.length >= 3 ? eTotal * 0.2 : elig.length === 2 ? eTotal * 0.1 : 0;
      tray.hidden = picked.length === 0;
      tray.querySelector('[data-rot-sum]').textContent = picked.length + (picked.length === 1 ? ' pair' : ' pairs') + ' · ' + money(total - save) + (save ? ' · you save ' + money(save) : '');
      tray.querySelector('[data-rot-msg]').textContent = elig.length < 2 ? 'Add ' + (2 - elig.length) + ' more pair' + (elig.length ? '' : 's') + ' for 20% off the 2nd' : elig.length === 2 ? 'Add a 3rd pair and it\'s 60% off' : 'Best saving reached';
      tray.querySelector('[data-rot-prog]').style.width = Math.min(100, elig.length / 3 * 100) + '%';
      root.querySelectorAll('[data-rot-ladder] [data-n]').forEach(function (d) { d.classList.toggle('on', +d.getAttribute('data-n') === Math.max(1, Math.min(3, elig.length))); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rot-add]'); if (!b) return;
      var card = b.closest('[data-rot-card]'); var h = card.getAttribute('data-h');
      var i = picked.findIndex(function (x) { return x.h === h; });
      if (i >= 0) { picked.splice(i, 1); b.setAttribute('aria-pressed', 'false'); b.textContent = card.getAttribute('data-elig') === 'true' ? 'Add to rotation' : 'Add'; paint(); return; }
      var sel = card.querySelector('[data-rot-size]'); var opt = sel.options[sel.selectedIndex];
      if (!sel.value) { sel.classList.add('need'); sel.focus(); return; }
      sel.classList.remove('need');
      picked.push({ h: h, id: +sel.value, p: +opt.getAttribute('data-p'), elig: card.getAttribute('data-elig') === 'true' });
      b.setAttribute('aria-pressed', 'true'); b.textContent = 'Added · ' + opt.textContent.trim();
      paint();
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-rot-size]')) e.target.classList.remove('need'); });
    tray.querySelector('[data-rot-go]').addEventListener('click', function () {
      var go = this; go.disabled = true; go.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: picked.map(function (x) { return { id: x.id, quantity: 1 }; }) }) })
        .then(function (r) { if (!r.ok) throw new Error(); location.href = '/cart'; })
        .catch(function () { go.disabled = false; go.textContent = 'Add all to bag'; tray.querySelector('[data-rot-msg]').textContent = 'That size has just sold out. Choose another and try again.'; });
    });
  });
})();
